export const TEST_USER_EMAIL = 'fuuzetest@fuuze.app';
